// Renders the app-level logo - always the bundled SYMIN logo.
// The consultant logo (Admin → Branding) is used ONLY for report creation/branding.
// `dark` selects the light-wordmark variant for dark backgrounds.
export function BrandLockup({ dark = false, className = "" }) {
  const src = dark ? "/symin-logo-dark.png" : "/symin-logo.png";
  return (
    <img
      src={src}
      alt="SYMIN"
      className={`h-9 sm:h-10 w-auto max-w-[210px] object-contain ${className}`}
      data-testid="brand-logo"
    />
  );
}
